import { render, staticRenderFns } from "./PrintosHeader.vue?vue&type=template&id=6838c10e"
import script from "./PrintosHeader.vue?vue&type=script&lang=js"
export * from "./PrintosHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports